import { Icon } from "semantic-ui-react";
import { FieldDescriptor } from "@crispico/foundation-react";

export class Flight_OnHoldFieldDescriptor extends FieldDescriptor {
    renderField(entity: any) {
        return entity.onHold ? <div><Icon name="stop circle outline" color="grey" size="large" /></div> : null;
    }
}